import { api } from "./api";

export interface UserMetrics {
  coursesCompleted: number;
  totalEnrolled: number;
  completionRate: number;
  quizzesPassed: number;
  quizzesAttempted: number;
  quizAccuracy: number;
  averageQuizScore: number;
  lessonsCompleted: number;
  totalLessons: number;
  learningStreak: number;
  longestStreak: number;
  totalXP: number;
  badgesEarned: number;
  totalBadges: number;
  forumPosts: number;
  mentorshipSessions: number;
  certificatesEarned?: number;
  lastActiveDate?: string;
  averageSessionDuration: number;
}

export interface EvaluationInsights {
  bestPerformingCategory?: string;
  worstPerformingCategory?: string;
  peakLearningHour?: number;
  preferredContentType?: string;
  improvementTrend?: "improving" | "stable" | "declining";
}

export interface EvaluationRecommendation {
  type: "course" | "quiz" | "schedule" | "engagement" | "skill" | "study_habit";
  priority: "low" | "medium" | "high" | "urgent";
  title: string;
  description: string;
  actionUrl?: string;
  icon?: string;
  completed?: boolean;
}

export interface UserEvaluation {
  _id: string;
  user?: {
    _id: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    username?: string;
  };
  overallScore: number;
  grade: "A" | "B" | "C" | "D" | "F";
  metrics: UserMetrics;
  evaluation: {
    strengths: string[];
    weaknesses: string[];
    learningStyle: "visual" | "auditory" | "kinesthetic" | "reading" | "mixed";
    engagementLevel: "low" | "moderate" | "high" | "excellent";
    consistencyLevel: "inconsistent" | "moderate" | "consistent" | "excellent";
  };
  recommendations: EvaluationRecommendation[];
  insights: EvaluationInsights;
  calculatedAt: string;
  nextEvaluationDue?: string;
}

export const evaluationApi = {
  getMyEvaluation: () => {
    return api.get<{ success: boolean; data: UserEvaluation | null }>(
      "/evaluation/my/evaluation",
    );
  },

  triggerMyEvaluation: () => {
    return api.post<{ success: boolean; data: UserEvaluation }>(
      "/evaluation/my/evaluation/trigger",
    );
  },

  adminGetUserEvaluation: (userId: string) => {
    return api.get<{ success: boolean; data: UserEvaluation }>(
      `/evaluation/admin/user/${userId}`,
    );
  },

  adminTriggerUserEvaluation: (userId: string) => {
    return api.post<{ success: boolean; data: UserEvaluation }>(
      `/evaluation/admin/user/${userId}/evaluate`,
    );
  },

  adminGetTopPerformers: (limit = 10) => {
    return api.get<{ success: boolean; count: number; data: any[] }>(
      `/evaluation/admin/top-performers?limit=${limit}`,
    );
  },

  adminGetUsersNeedingSupport: (limit = 20) => {
    return api.get<{ success: boolean; count: number; data: any[] }>(
      `/evaluation/admin/users-needing-support?limit=${limit}`,
    );
  },
};
